import { Component, OnInit, OnDestroy, AfterContentInit } from '@angular/core';
import { AuthenticationService } from '../_services/authentication.service';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { ProfileService } from '../_services/profiles.service';
import { Subscription } from 'rxjs/Subscription';

import { User } from '../_models/user.model';
import { first } from 'rxjs/operators';
import { Profile } from '../_models/profile.model';
import { EnvironmentService } from '../_services/environment.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-profile-selector',
  templateUrl: './profile-selector.component.html',
  styleUrls: ['./profile-selector.component.scss'],
})
export class ProfileSelectorComponent implements OnInit, OnDestroy {
  // Determines if the accordion will be opened or closed
  isOpen = true;
  // FontAwesome icons
  faCaretDown = faCaretDown;
  faCaretUp = faCaretUp;
  // END of FontAwesome icons

  userProfiles: Profile[];
  currentProfile: Profile;
  profilesSubscription: Subscription;
  userSubscription: Subscription;
  isUserAuthenticated = false;
  loadingProfiles = false;
  errorLoadingProfiles = false;
  profilesLoaded = false;

  profileImageName = 'category-1';

  constructor(
    private authService: AuthenticationService,
    private profilesService: ProfileService,
    private environmentService: EnvironmentService,
    private router: Router
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this.isOpen = this.currentProfile ? false : true;
      this.userSubscription = this.authService.currentUser.subscribe(
        (user: User) => {
          if (user && user.authToken) {
            this.isUserAuthenticated = true;
            this.getUserProfiles();
          } else {
            this.isUserAuthenticated = false;
          }
        }
      );
    });
  }

  getProfileImage(name: string) {
    const imagesPerProfile = this.environmentService.profileImageRelation;
    const imageUrl = imagesPerProfile.find(imgr => {
      return imgr.role === name;
    });
    if (imageUrl) {
      return imageUrl.imageName;
    } else {
      return 'default.png';
    }
  }

  getUserProfiles() {
    this.loadingProfiles = true;
    this.profilesSubscription = this.profilesService
      .getProfiles()
      .pipe(first())
      .subscribe(
        (profiles: Profile[]) => {
          const tempProfiles: Profile[] = [];
          profiles.forEach((pr: Profile) => {
            pr.profile_image_name = this.getProfileImage(pr.profile_name);
            tempProfiles.push(pr);
          });
          this.loadingProfiles = false;
          this.userProfiles = tempProfiles;
          this.profilesLoaded = true;
        },
        error => {
          this.loadingProfiles = false;
          this.errorLoadingProfiles = true;
          const errorObject = error as HttpErrorResponse;
          console.log(error);
          console.log(errorObject.status);
          if (errorObject.status === 401) {
            this.authService.logout();
            this.router.navigate(['/logout']);
            // const logBackURL =
            //   this.environmentService.cafamLoginURL +
            //   this.environmentService.appReturnURL;
            // location.replace(logBackURL);
          }
        }
      );
  }

  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
    if (this.profilesSubscription) {
      this.profilesSubscription.unsubscribe();
    }
  }

  // getHeading(): string {
  //   return this.currentProfile ? (this.currentProfile.toString()) : 'Selección de Perfil';
  // }

  public onSelectProfile(id: number) {
    this.profilesService.setSelectedProfile(id);
    this.currentProfile = this.profilesService.getSelectedProfile();
    if (this.currentProfile) {
      this.isOpen = false;
    }
  }

  public isProfileCurrentProfile(profile: Profile) {
    const cprof = this.profilesService.getSelectedProfile();
    if (cprof) {
      return profile.counter === cprof.counter;
    }
    return false;
  }

  toggleOpenAccordion() {
    if (this.isOpen) {
      // if (this.currentProfile) {
      this.isOpen = !this.isOpen;
      // }
    } else {
      this.isOpen = !this.isOpen;
    }
  }

  LogOpenChanged(accordionWasOpened) {
    if (accordionWasOpened) {
      this.isOpen = true;
    }
  }
}
